/* Primal Wine — glossary tooltips
 * Enhances real, server-rendered anchors:
 *   <a class="pw-gloss" href="/blogs/wine-101/natural-wine-glossary#slug"
 *      data-slug="slug">term</a>
 * On hover / focus / tap it shows a small card (term + one-line definition +
 * "Learn more"). Clicking the term navigates to its glossary entry. Because the
 * anchor is in the HTML, the link is crawlable (internal-linking SEO) and works
 * with JS off (progressive enhancement).
 *
 * Fallback: any stray [[term]] / [[display|term]] text markers left in content
 * are converted to the same anchors at runtime, so brackets never render raw.
 *
 * Term data (window.PW_GLOSSARY / PW_GLOSSARY_ALIAS) is lazy-loaded from
 * glossary-tooltip-data.js only when at least one trigger is present.
 *
 * Config from the injecting <script> data attributes:
 *   data-scope     CSS selector(s) for content containers (comma separated)
 *   data-data-src  URL of glossary-tooltip-data.js
 *   data-glossary  base URL of the glossary page (anchors appended as #slug)
 */
(function () {
  "use strict";
  var self = document.currentScript;
  var SCOPE = (self && self.dataset.scope) || ".article__content, .rte";
  var DATA_SRC = self && self.dataset.dataSrc;
  var GLOSSARY_URL =
    (self && self.dataset.glossary) ||
    "/blogs/wine-101/natural-wine-glossary";

  var MARKER = /\[\[([^\]]+)\]\]/g; // [[display|term]] or [[term]]

  function norm(s) {
    return s
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[-_/]/g, " ")
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function slugFor(text) {
    var k = norm(text);
    return (window.PW_GLOSSARY_ALIAS && window.PW_GLOSSARY_ALIAS[k]) || k;
  }
  function entryFor(slug) {
    return window.PW_GLOSSARY && window.PW_GLOSSARY[slug]
      ? window.PW_GLOSSARY[slug]
      : null;
  }

  function makeAnchor(display, slug) {
    var a = document.createElement("a");
    a.className = "pw-gloss";
    a.setAttribute("data-slug", slug);
    a.setAttribute("href", GLOSSARY_URL + "#" + slug);
    a.textContent = display;
    return a;
  }

  // ---- Fallback: convert stray [[markers]] in text nodes into anchors ----
  function convertMarkers() {
    var containers = document.querySelectorAll(SCOPE);
    var textNodes = [];
    containers.forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || node.nodeValue.indexOf("[[") === -1)
            return NodeFilter.FILTER_REJECT;
          var p = node.parentNode;
          while (p && p !== root) {
            var t = p.nodeName;
            if (t === "A" || t === "SCRIPT" || t === "STYLE")
              return NodeFilter.FILTER_REJECT;
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      var n;
      while ((n = walker.nextNode())) textNodes.push(n);
    });
    textNodes.forEach(function (node) {
      var text = node.nodeValue;
      MARKER.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0,
        m,
        any = false;
      while ((m = MARKER.exec(text))) {
        any = true;
        if (m.index > last)
          frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var parts = m[1].split("|");
        var display = parts[0].trim();
        var slug = slugFor((parts[1] || parts[0]).trim());
        frag.appendChild(makeAnchor(display, slug));
        last = m.index + m[0].length;
      }
      if (!any) return;
      if (last < text.length)
        frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  // ---- Shared popover ----
  var pop, popTitle, popDef, popLink, activeTrigger, hideTimer;

  function buildPop() {
    pop = document.createElement("div");
    pop.className = "pw-gloss-pop";
    pop.setAttribute("role", "tooltip");
    pop.innerHTML =
      '<span class="pw-gloss-pop__term"></span>' +
      '<span class="pw-gloss-pop__def"></span>' +
      '<a class="pw-gloss-pop__link" href="#">Learn more <span aria-hidden="true">&rarr;</span></a>' +
      '<span class="pw-gloss-pop__arrow" aria-hidden="true"></span>';
    document.body.appendChild(pop);
    popTitle = pop.querySelector(".pw-gloss-pop__term");
    popDef = pop.querySelector(".pw-gloss-pop__def");
    popLink = pop.querySelector(".pw-gloss-pop__link");
    pop.addEventListener("mouseenter", function () {
      clearTimeout(hideTimer);
    });
    pop.addEventListener("mouseleave", scheduleHide);
  }

  function slugOf(trigger) {
    var s = trigger.getAttribute("data-slug");
    if (s) return s;
    var href = trigger.getAttribute("href") || "";
    var i = href.indexOf("#");
    if (i !== -1) return href.slice(i + 1);
    return slugFor(trigger.textContent || "");
  }

  function position(trigger) {
    var r = trigger.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var pad = 8;
    var top = r.top - pr.height - 10;
    var below = false;
    if (top < pad) {
      top = r.bottom + 10;
      below = true;
    }
    var left = r.left + r.width / 2 - pr.width / 2;
    left = Math.max(pad, Math.min(left, window.innerWidth - pr.width - pad));
    pop.style.top = top + window.scrollY + "px";
    pop.style.left = left + window.scrollX + "px";
    pop.classList.toggle("pw-gloss-pop--below", below);
    var arrow = pop.querySelector(".pw-gloss-pop__arrow");
    var ax = r.left + r.width / 2 - left;
    arrow.style.left = Math.max(12, Math.min(ax, pr.width - 12)) + "px";
  }

  function show(trigger) {
    var slug = slugOf(trigger);
    var data = entryFor(slug);
    if (!data) return;
    clearTimeout(hideTimer);
    activeTrigger = trigger;
    popTitle.textContent = data.t;
    popDef.textContent = data.d;
    popLink.setAttribute("href", GLOSSARY_URL + "#" + slug);
    pop.classList.add("pw-gloss-pop--on");
    position(trigger);
  }
  function hide() {
    pop.classList.remove("pw-gloss-pop--on");
    activeTrigger = null;
  }
  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 120);
  }

  function bind(trigger) {
    trigger.addEventListener("mouseenter", function () {
      show(trigger);
    });
    trigger.addEventListener("mouseleave", scheduleHide);
    trigger.addEventListener("focus", function () {
      show(trigger);
    });
    trigger.addEventListener("blur", scheduleHide);
    // Click: if the card is already open for this trigger (desktop hover, or a
    // second tap on touch) let the link navigate; otherwise first tap opens it.
    trigger.addEventListener("click", function (e) {
      if (activeTrigger === trigger) return; // navigate
      e.preventDefault();
      show(trigger);
    });
  }

  function init() {
    convertMarkers(); // fallback: absorb any stray [[markers]]
    var triggers = [].slice.call(document.querySelectorAll("a.pw-gloss"));
    if (!triggers.length) return;
    buildPop();

    function activate() {
      triggers.forEach(function (t) {
        if (entryFor(slugOf(t))) bind(t);
        else t.classList.add("pw-gloss--unknown");
      });
    }
    if (window.PW_GLOSSARY) {
      activate();
    } else if (DATA_SRC) {
      var s = document.createElement("script");
      s.src = DATA_SRC;
      s.onload = activate;
      s.onerror = function () {}; // links still work without the card
      document.head.appendChild(s);
    }

    window.addEventListener("scroll", scheduleHide, { passive: true });
    window.addEventListener("resize", hide);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hide();
    });
    document.addEventListener("click", function (e) {
      if (
        activeTrigger &&
        !e.target.closest(".pw-gloss") &&
        !e.target.closest(".pw-gloss-pop")
      )
        hide();
    });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
